import {createSlice} from '@reduxjs/toolkit';

const slice = createSlice({
    name: "app",
    initialState: {
        investment: []
    },
    reducers: {
        //actions => action handlers
        INVESTMENT: (state, action) => {
            return {
                ...state,
                investment: action.payload.investment
            }
        }
    }
});

export const {INVESTMENT} = slice.actions;
export default slice.reducer;
